


































































import { Component, Vue ,Prop,Watch} from "vue-property-decorator";
import Sidebar from "../components/Sidebar.vue";
import MySettings from '../components/MySettings.vue';
import { store, StoreState ,AppSettings,HellospokeUser} from "../store";
import { mapState } from "vuex";
import VueElementLoading from "vue-element-loading"; 
import { RotateSquare2 } from "vue-loading-spinner";
import DashLogo from "../components/DashLogo.vue";
import QuickCall from '../components/QuickCall.vue';
import AES from 'crypto-js/aes';  
import CryptoJS from 'crypto-js';
import moment from "moment";
import axios from  'axios';    
import { watch } from "fs";  

declare interface AdminData {
		users: HellospokeUser[];
  }


@Component({
  components: {
    Sidebar,MySettings,
    RotateSquare2,
    VueElementLoading,DashLogo  ,QuickCall
  },  
  computed: {
    ...mapState({
        'jwt': (state: StoreState) => state.account.jwt,
        'conferenceattendeesectionlist': (state: StoreState) => state.dashboard.AttendeeSectionList,
        'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
        'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
        'channels': (state: StoreState) => state.dashboard.Channels,
        'devices': (state: StoreState) => state.dashboard.Devices,
        'ongoincalls': (state: StoreState) => state.dashboard.OnGoinCalls,
        'Account_id': (state: StoreState) => state.account.account_id ,
        'user_image_url': (state: StoreState) => state.dashboard.user_image_url,    
        'logger_userid': (state: StoreState) => state.dashboard.logger_userid,
        'token_id': (state: StoreState) =>state.account.jwt
    })
  },
  mounted(){
    // this.myStopFunction();
  }

  
 
})
export default class Dashboard extends Vue {
   private conferenceattendeesectionlist: any[];

  data() {
    return {
      Users: [],
      fullNames: [],
      search_text: "",
      org_fullNames: [],
      noDataDisplay: false,
      URLIMGPLUS_G:"/img/rose-blue.jpeg",
      person:"/img/icons/person_icons.png",
      is_loading:false,
       show_seachicon:false
    
    };
  }

  @Prop()
    public users!: HellospokeUser[];
    
  
  @Watch('user_image_url')
  updateuserimage()
  {
    var id=(this as any).userid;  
    this.$data.fullNames
        var UserImagefound = this.$data.fullNames.find(function(element) {
            return element._id ==id;  
          });
      if (UserImagefound)
        UserImagefound.imageUrl= (this as any).user_image_url;
  }


  @Watch ('ongoincalls')
  SetCallDetailsforincommingcalls()
  {
    
    var _ongoincalls= (this as any).ongoincalls
    if (_ongoincalls.length)
    {
      var _call = _ongoincalls.pop();
      if (_call && (_call.name === 'CHANNEL_CREATE' ||  _call.event_name === 'CHANNEL_CREATE') )
      {
           this.processCall(_call);
      }
      else  if (_call && ( _call.name === 'CHANNEL_DESTROY' ||_call.event_name === 'CHANNEL_DESTROY' )) 
      {
          this.EndCall(_call);
      }
    }

 }
 
 
 @Watch ('channels')
  SetCallDetails()
  {
    var _channels = (this as any).channels;
    _channels.forEach(element => {
    this.processCall(element);
    });
  }

  async EndCall(element:any)
  {
       var _user = this.$data.fullNames.find((e: any) => {
           return (element.call_id ===e.call_id) || (element.custom_channel_vars.call_interaction_id===e.interaction_id);
       });
        if ( _user.call) {
            _user.call=false;
            delete _user.call_id;
            delete _user.call_details; 
            delete _user.interaction_id;
            var fname= _user.full_name;
            _user.full_name=fname + ' ';
            _user.full_name=fname;
            clearInterval(_user.interval);
        }
        
  }
	
    async processCall(element:any)
    {
       var _devices  =(this as any).devices;
       var _user = this.$data.fullNames.find((e: any) => {
             return !e.call && ( (element.presence_id &&  element.presence_id.includes(e.presence_id))||
            (element.from &&  element.from.includes(e.presence_id ))) ;
          });
             /* var _device = _devices.find((e: any) => {
                                return   element.caller_id_name.includes(e.username);
                            });*/
          if( _user.call) return;
              _user.call=true;
              _user.call_id= element.call_id;
              _user.interaction_id= element.interaction_id;
              _user.call_details= {
              from:element.caller_id_name? element.caller_id_name : element.from,
              to:element.callee_id_name? element.callee_id_name : element.to,
              time:element.elapsed_s? element.elapsed_s :1
            };
            var dur=element.elapsed_s?element.elapsed_s:1;
             if (dur) {
                  let ms: any = moment.duration(dur, "seconds");
                  _user.interval= setInterval(() => {
                      _user.call_details.time = this.alterTime(ms);
                      var fname= _user.full_name;
                      _user.full_name=fname + ' ';
                      _user.full_name=fname;
                      ms._milliseconds += 1000;
                }, 1000);
             }
            var fname= _user.full_name;
            _user.full_name=fname + ' ';
            _user.full_name=fname;
    }


    async created() {
    this.inactivityTime();
      this.$data.is_loading = true;
      var id=(this as any).Account_id;  
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + (this as any).jwt;
			await  axios.get(`${AppSettings.API_HOST}admin/accounts/${id}/users`).then(r => {  
          this.$data.is_loading = false;
            this.$data.Users = r.data.docs;
           this.$store.commit('SET_DASHBOARD_USERS',this.$data.Users);
            let fullNames = r.data.docs.map(({first_name,imageUrl,last_name,presence_id,username,_id}) => {
              return {
                full_name: `${first_name} ${last_name}`,
                imageUrl: imageUrl,
                presence_id:`${presence_id}`,
                code: first_name.charAt(0)+''+last_name.charAt(0),
                username,
                _id:_id
              };
            });
            fullNames.sort(function(a, b) {
              const nameA = a.full_name.toLowerCase(),
                nameB = b.full_name.toLowerCase();
              if (nameA < nameB){
                 //sort string ascending
                return -1;
              }
              else if (nameA > nameB) {
                    return 1;
                }
              else{
                  return 0; //default return value (no sorting)
              }
            });
            const haveHashNum = [];
            const haveLetters = [];
            const haveNum = [];
            fullNames.map(o => {
              if (isNaN(o.full_name)) {
                if (o.full_name.match(/^\d/) ) {
                  haveHashNum.push(o);
                } else {
                  haveLetters.push(o);
                }
              } 
              else {
                haveNum.push(o);
              }
            });
            fullNames = [];
            fullNames = [...haveLetters, ...haveNum, ...haveHashNum];
            this.$data.org_fullNames = [...fullNames];
            this.filterUsers(fullNames);
				})
				.catch(r => {
                    this.$store.commit('SET_ADMIN_LOADER',false)
					console.warn(r);
				});
      
     
         await  this.$store.dispatch("getChannelDevices");
          await this.$store.dispatch("getChannels").then(r=>{ //this.SetCallDetails();
          });
          this.$store.dispatch("createBlackholeSocket");
         // await this.$store.dispatch('getTextPermissions');
          //this.$store.dispatch('createNotificationsSocket');
         
          // this.$store.dispatch('checkNotifications').then(async (r) => {
          //   this.$store.commit('SET_NOTIFICATION_REFRESH',false); 
          //     }
            //);
            }

    search_inputclick()
      {
         var x = document.getElementById("input_searchicon");
          x.style.display = "none";
      }

    search_inputblur()
      {
        var x = document.getElementById("input_searchicon");
        if(this.$data.search_text.length!=0){
          x.style.display = "none";
        }
        else{
          x.style.display = "inline";
        }
      }
        
   focusInput() 
      { 
              document.getElementById("input_search").focus(); 
              var x = document.getElementById("input_searchicon");
            x.style.display = "none";
      } 

      
    alterTime(dur) {
      let time = dur; //moment.duration(957146, 'seconds');
      return (time as any).format("dd:hh:mm:ss"); //`${time.day}:${time.hour}:${time.minute}:${time.seconds}`;
    }
   get loger_Name(){   
      this.$data.notifications_open = true;
      var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
      Login_User=Login_User.substring(0,Login_User.indexOf('@'));
      return Login_User
        }


    searchNames() {
     // this.$data.show_seachicon=this.$data.search_text.length!=0?true:false;
      let fullNames = this.$data.org_fullNames.filter(obj => {
        return obj.full_name.toLowerCase().includes(this.$data.search_text.toLowerCase());
      });
      this.filterUsers(fullNames);
    }

  filterUsers(fullNames) {
    if (fullNames.length > 0) {
      this.$data.noDataDisplay = false;
      let curr,
        next,
        collect = [];
      for (let j = 0; j < fullNames.length; j++) {
        const curr = fullNames[j].full_name.charAt(0).toUpperCase();
        if (j + 1 < fullNames.length) {
          const next = fullNames[j + 1].full_name.charAt(0).toUpperCase();
          if (curr && next) {
            if (curr === next) {
              collect.push(fullNames[j]);
            } else {
              collect.push(fullNames[j]);
              collect.push({
                full_name: fullNames[j + 1].full_name.charAt(0).toUpperCase(),
                class: "alphanum"
              });
            }
          }
        }
      }
      collect.push(fullNames[fullNames.length - 1]);
      collect.unshift({
        full_name: fullNames[0].full_name.charAt(0).toUpperCase(),
        class: "alphanum"
      });
      this.$data.fullNames = [...collect];
    } else {
      this.$data.noDataDisplay = true;
    }
  }


  quickCall(number) {
            this.$store.commit('QUICK_CALL', number);
    }
    
    
 inactivityTime = function () {

  //this.myStopFunction();
  var time;
  var self=this;
  window.onload = this.resetTimer;
  window.onbeforeunload=this.resetTimer;
     
    // DOM Events
  document.onload = this.resetTimer;
  document.onmousemove = this.resetTimer;
  document.onmousedown = this.resetTimer; // touchscreen presses
  document.ontouchstart = this.resetTimer;
  document.onclick = this.resetTimer;     // touchpad clicks
  document.onscroll = this.resetTimer;    // scrolling with arrow keys
  document.onkeypress = this.resetTimer;  
   };
    logout() {
      var time;
      this.myStopFunction();
      //console.log("You are now logged out.")  ;
      if(!(window.location.pathname=='/login')){ 
          clearTimeout(time);
          this.$store.commit('LOGOUT_STATUS' , true);  
      }
    }

    resetTimer() {
     
       var time;
       clearTimeout(time);
       //time = setTimeout(this.logout,  1000*60sec*60min*5hr); 
        time = setTimeout(this.logout, 1000*60*60*5);  //5hours
        
    }

     myStopFunction() {
       
       this.$store.commit('LOGOUT_STATUS' , false);  
      var time;
      clearTimeout(time);
    }
}
